<template>
  <router-view />
</template>
<script>
import { genNonDuplicateID } from "@/utils/util";
import { checkDevice } from "@/utils/DeviceUtil";
import { checkWebpSupport } from "@/utils/StaticPathUtil";
import { useWindowSize } from "@vueuse/core";

const { width } = useWindowSize();

export default {
  name: "App",
  data() {
    return {
      width: width,
    };
  },
  mounted() {
    window.vue.mewBrowserId = genNonDuplicateID();
    checkDevice(this.width);
    checkWebpSupport();
  },
  unmounted() {

  },
  watch: {
    width: function (new_value, old_value) {
      checkDevice(new_value);
    },
  },
  props: {

  },
  computed: {

  },
  components: {

  },
  methods: {

  },
};
</script>